import React from "react";

//css
import "./InfoFlyout.scoped.scss";

const InfoFlyout = ({ icon, value, indicator, upColor = "red", downColor = "green" }) => {
	// indicator = -1 -> fall
	// indicator = 1  -> rise

	return (
		<div>
			{icon}
			<p className="val">{value}</p>
			{indicator === -1 && <i className="fas fa-caret-down" style={{ color: downColor }} />}
			{indicator === 1 && <i className="fas fa-caret-up" style={{ color: upColor }} />}
		</div>
	);
};

export default InfoFlyout;
